<template>
  <div class="profile-view">
    <Header
        v-if="showHeader"
        :siteSectionOpen="siteSectionOpen"
        :mobileOpen="mobileOpen"
        v-on:openprofilesettings="openProfileSettings"
        v-on:openmobilemenu="openMobileMenu"
        v-on:closemobilemenu="closeMobileMenu"/>
    <div class="profile-wrapper">
      <div class="profile-dashboard" :class="{active: mobileOpen}">
        <div class="menu-item transparent mobile-hidden">
          <button @click="toggleLockProfile" class="btn btn-main w-100 mb-1 text-ellipsis">
            <span v-if="currentProfileIsActive">{{ $lang.messages.unlock }}</span>
            <span v-else>{{ $lang.messages.profile.lock }}</span>
            {{activeProfile.kidName || 'Kid'}} {{ $lang.messages.profile.profile }}
          </button>
          <button @click="$router.back()" class="btn btn-outline flex-v-center w-100">
            <svg class="rotate-180 mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 8H14M14 8L6.92857 1M14 8L6.92857 15" stroke="#9485EF" stroke-width="2"/>
            </svg>
            {{ $lang.messages.profile.back_to_dashboard }}
          </button>
        </div>
        <div class="dashboard-menu">
          <Menu
              v-for="(component) in menu"
              v-bind="component"
              :currentab="currentTab"
              :key="component.key"
              :showActive="siteSectionOpen"
              v-on:openmenuitem="openmenuitem"
          />
        </div>
      </div>
      <div class="profile-tabs mobile-hidden">
        <div class="profile-tabs-list">
          <div v-for="(profile, index) in profiles" :key="index" class="profile-tab"
               :class="{active: activeProfileIndex === index}" @click="chooseProfile(index)">
            <div class="profile-tab-image">
              <img :src="profile.avatar || $avatars[profile.defaultAvatarId || 13]" alt="image">
            </div>
            <div class="profile-tab-name">
              {{profile.kidName || 'Kid'}} <br>
            </div>
          </div>
        </div>
        <div @click="goAddProfile" class="add-profile-tab">+</div>
      </div>
      <div class="content-block" v-if="profiles">
        <component
            :is="currentTabComponent"
            :profileId="activeProfileIndex"
            :profile="activeProfile"
            v-on:openmobilemenu="openMobileMenu"
            v-on:removeprofile="removeProfile"
            v-on:showloginmodal="showMessageInLogin = false; showLoginModal = true"
            v-on:openmenuitem="openmenuitem"
            v-on:openonlypremiummodal="showOnlyPremiumModal = true"
        ></component>
        <PremiumModal v-if="showOnlyPremiumModal"
                      v-on:openmenuitem="openmenuitem"
                      v-on:closepremiummodal="showOnlyPremiumModal = false"
                      v-on:showpremiummodal="getPremium"/>
        <GetPremiumModal v-if="showGetPremium"
                         :customer="settings.customer"
                         v-on:closepremiummodal="showGetPremium = false"
                         v-on:premiumispurchased="showPremiumIsPurchased = true"
                         v-on:updatesettings="saveAccountSettings"/>
        <GetPremiumModalAndroid v-if="showGetPremiumAndroid"
                                v-on:closepremiummodal="showGetPremiumAndroid = false" />
        <PremiumPurchasedModal
            v-show="showPremiumIsPurchased"
            v-on:closemodal="showPremiumIsPurchased = false"/>
      </div>
    </div>
    <Modal size="sm" v-if="showCreateKidModeModal" @hidemodal="showCreateKidModeModal = false">
      <div slot="header" class="content-block-title mb-0 mt-0 mr-2">{{ $lang.messages.dashboard.run_kids_mode_modal_title }}</div>
      <div slot="content">
        <LockDeviceWithProfile
            @startkidsmode="lockDeviceWithProfile"
            :default-device="currentDeviceID ? currentDeviceID : false"
            :default-profile="activeProfileIndex"
        />
      </div>
    </Modal>
    <Modal v-if="showAddChildPopup" @hidemodal="showAddChildPopup = false" lowheader="true">
      <AddChildPopup
          slot="content"
          v-on:showaddlinkmodal="showAddLinkModal = true"
          v-on:adddeviceshow="addDeviceShow = true"
          v-on:closeaddchild="showAddChildPopup = false"
      />
    </Modal>
    <AddDevice v-if="addDeviceShow"
               v-on:closepopup="addDeviceShow = false"
               defaultOpenScreen="mobile"
    />
  </div>
</template>

<script>

import "firebase/storage"
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import {mapGetters, mapState} from "vuex";
import Sites from "@/components/Sites";
import saveSetting from '../components/mixins/saveSetting'
import Backgrounds from "@/components/Themes";
import {reportEvent, getSessionDuration} from "@/helpers/utils";
import Header from "../components/Header"
import Statistics from "../components/Statistics"
import ProfileLimits from "../components/ProfileLimits"
import Menu from "../components/Menu"
import ProfileSettings from "../components/ProfileSettings"
import Premium from "@/components/Premium";
import PremiumModal from "@/components/PremiumModal";
import GetPremiumModal from "@/components/GetPremiumModal";
import GetPremiumModalAndroid from "@/components/GetPremiumModalAndroid";
import PremiumPurchasedModal from "@/components/PremiumPurchasedModal";
import LockDeviceWithProfile from "@/components/LockDeviceWithProfile";
import Modal from "@/components/common/Modal";
import AddChildPopup from "@/components/AddChildPopup";
import AddDevice from "@/components/AddDevice";

export default {
  name: 'Profile',
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    showTabs: {
      type: Boolean,
      default: true
    },
    showLockButton: {
      type: Boolean,
      default: false
    },
    propsProfile: {
      type: String,
      default: ''
    },
  },
  mixins: [saveSetting],
  data: function (){
    return {
      activeProfileIndex: this.$route.query.id ||
          this.$route.params.profileId ||
          this.propsProfile ||
          this.profiles[Object.keys(this.profiles)[0]],
      avatarLoading: false,
      showEditTimeModal: false,
      showGiveBonusTime: false,
      editTimeDayId: null,
      editTimeDay: null,
      editTimeModalCurrent: null,
      editTimeModalCurrentAdditional: null,
      editTimeModalBlockDay: null,
      currentTab: "Statistics",
      siteSectionOpen: window.innerWidth > 767,
      showOnlyPremiumModal: false,
      showGetPremium: false,
      showGetPremiumAndroid: false,
      showPremiumIsPurchased: false,
      mobileOpen: false,
      showCreateKidModeModal: false,
      showAddChildPopup: false,
      addDeviceShow: false,
      menu: [
        {
          key: 1,
          titleID: 'Statistics',
          title: this.$lang.messages.menu.statistics.title,
          icon: 'statistic.svg',
          isHiddenMobile: true
        },
        {
          key: 2,
          titleID: 'ProfileLimits',
          title: 'Screen time',
          icon: 'settings.svg',
        },
        {
          key: 3,
          titleID: 'Sites',
          title: this.$lang.messages.menu.sites.title,
          icon: 'sites.svg',
        },
        {
          key: 4,
          titleID: 'Backgrounds',
          title: this.$lang.messages.menu.themes.title,
          icon: 'themes.svg',
        },
        {
          key: 5,
          titleID: 'ProfileSettings',
          title: 'Profile',
          icon: 'settings.svg',
        },
      ],
      dailyLimitOptions: [
        {
          label: '30 min',
          value: 1800,
        },
        {
          label: '1 hour',
          value: 3600,
        },
        {
          label: '1h 30m',
          value: 5400,
        },
        {
          label: '2 hours',
          value: 7200,
        },
        {
          label: '3 hours',
          value: 10800,
        },
        {
          label: '4 hours',
          value: 14400,
        },
        {
          label: 'Unlimited',
          value: 86400,
        },
      ],
    }
  },
  components: {
    Menu,
    Statistics,
    Header,
    Backgrounds,
    Sites,
    Loading,
    ProfileSettings,
    ProfileLimits,
    Premium,
    PremiumModal,
    GetPremiumModalAndroid,
    GetPremiumModal,
    PremiumPurchasedModal,
    LockDeviceWithProfile,
    Modal,
    AddChildPopup,
    AddDevice
  },
  mounted() {
    window.scrollTo(0,0)
    if(this.$route.query.menuItem){
      this.currentTab = this.$route.query.menuItem
    }
  },
  computed: {
    currentTabComponent: function() {
      return this.currentTab;
    },
    activeProfile () {
      return this.profiles[this.activeProfileIndex] || null
    },
    ...mapGetters({
      activeProfiles: 'activeProfiles',
    }),
    ...mapState({
      profiles: state => state.accountData.profiles,
      user: state => state.user,
      settings: state => state.accountData,
      currentDeviceID: state => state.currentDeviceID
    }),
    currentProfileIsActive(){
      return this.activeProfiles[this.activeProfileIndex]
    }
  },
  methods: {
    toggleLockProfile(){
      if (this.currentProfileIsActive){
        const deviceIDToUnlock = this.activeProfiles[this.activeProfileIndex].deviceID;
        const sessionDuration = this.activeProfile.startSessionTime ? getSessionDuration(this.activeProfile.startSessionTime) : null;

        reportEvent('exitKidsMode', {
          isRemote: deviceIDToUnlock !== this.currentDeviceID,
          sessionDuration,
        });
        this.saveDeviceSettings(deviceIDToUnlock, {
          locked: false,
          currentProfileID: null,
        })

      } else {
        this.showCreateKidModeModal = true
      }
    },
    openProfileSettings(){
      this.siteSectionOpen = false
      this.currentTab = 'Statistics'
    },
    goAddProfile(){
      if (this.settings.isPremium) {
        this.showAddChildPopup = true
      } else {
        this.showOnlyPremiumModal = true
      }
    },
    openMobileMenu(){
      this.mobileOpen = !this.mobileOpen
      document.body.classList.add('overflow-hidden')
    },
    closeMobileMenu(){
      this.mobileOpen = false
      document.body.classList.remove('overflow-hidden')
    },
    openmenuitem (title) {
      this.siteSectionOpen = true
      this.mobileOpen = false
      this.showOnlyPremiumModal = false
      this.currentTab = title
      window.scrollTo(0,0);
    },
    showPremiumPopup () {
      if(!this.settings.isPremium){
        this.$emit('openonlypremiummodal')
      }
    },
    getPremium () {
      if (window.Android) {
        this.showGetPremiumAndroid = true
      } else {
        this.showGetPremium = true
      }
      reportEvent('premiumDialogOpen', {src: 'Profile'})
    },
    removeProfile(profileId){
      this.activeProfileIndex = 'defaultProfileSettings';
      this.$router.replace('profile?id=defaultProfileSettings');
      this.saveProfileSettings(profileId, null, true);
    },
    chooseProfile(index){
      if (!this.settings.isPremium){
        this.showOnlyPremiumModal = true
      } else {
        this.activeProfileIndex = index
      }
    },
    lockDeviceWithProfile(profileToLock, deviceToLock) {
      this.showCreateKidModeModal = false

      reportEvent('startKidsMode', {
        isRemote: deviceToLock !== this.currentDeviceID,
      });

      this.saveDeviceSettings(deviceToLock,
        {
          locked: true,
          currentProfileID: profileToLock,
        });
    }
  }
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";
.profile {
  &-wrapper {
    display: flex;

    @include responsive-below($md){
      display: block;
    }
  }
  &-dashboard {
    flex: 0 0 310px;
    padding: 0;
    overflow: auto;
    background: #F5F7FB;
    transition: all .3s;

    @include responsive-below($md){
      position: fixed!important;
      width: 100%;
      height: 100%;
      z-index: 10;
      transform: translateX(-100%);
      background: #fff;
      padding: 20px;

      &.active {
        transform: translateX(0);
      }
    }
  }

  &-content {
    width: 100%;
    padding: 0 50px;

    @include responsive-below($sm){
      padding: 0;
    }
  }
}

.add-profile-tab {
  width: 40px;
  height: 40px;
  background: #FBFBFD;
  border-radius: 50%;
  text-align: center;
  line-height: 40px;
  border: 0;
  font-size: 25px;
  color: #7D6AED;
  cursor: pointer;
  
  &:hover {
    text-decoration: none;
  }
}
</style>


